import React, { useState, useEffect } from 'react';

export default function StatsSection() {
    const [counts, setCounts] = useState([0, 0, 0, 0]);

    const stats = [
        { target: 200, suffix: '+', label: 'Vendors', icon: '🤝' },
        { target: 654, suffix: 'K+', label: 'Sales', icon: '📈' },
        { target: 587, suffix: 'K+', label: 'Customers', icon: '😊' },
        { target: 4.9, suffix: '+', label: 'Happy Clients And Partners', icon: '⭐', isDecimal: true },
    ];

    useEffect(() => {
        const duration = 2000; // 2 seconds
        const steps = 50;
        const stepTime = duration / steps;
        let currentStep = 0;

        const timer = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;

            setCounts(
                stats.map(stat => {
                    if (stat.isDecimal) {
                        return Number(Math.min(stat.target, stat.target * progress).toFixed(1));
                    }
                    return Math.floor(stat.target * progress);
                })
            );

            if (currentStep >= steps) {
                clearInterval(timer);
                setCounts(stats.map(s => s.target));
            }
        }, stepTime);

        return () => clearInterval(timer);
    }, []);

    return (
        <section className="relative py-20 my-8 overflow-hidden bg-gray-900 shadow-lg">
            {/* Background Image with Bhagwa / Orange & Dark Gradient Overlay */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-30 scale-105"
                style={{ backgroundImage: `url('/background.jpg')` }} // Aap yahan apni public folder ki image ka path de sakte hain
            />
            {/* Bhagwa (Orange) aur Dark Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-orange-950/90 via-slate-900/90 to-orange-900/90" />

            {/* Content */}
            <div className="relative max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                {stats.map((stat, index) => (
                    <div
                        key={index}
                        className="p-6 bg-white/10 backdrop-blur-md rounded-3xl shadow-xl hover:bg-white/15 hover:-translate-y-1.5 transition-all duration-300 border border-white/20 group"
                    >
                        <div className="text-4xl mb-3 group-hover:scale-110 transition duration-300">
                            {stat.icon}
                        </div>
                        <h3 className="text-3xl md:text-5xl font-black text-orange-400 tracking-tight">
                            {counts[index]}{stat.suffix}
                        </h3>
                        <p className="text-xs md:text-sm font-bold text-gray-100 mt-2 uppercase tracking-wider">
                            {stat.label}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}